import api from '@/api'

const { $academic, $pricing } = api;

export const { $careers } = $academic;
export const { $prices, $products, $types, $zones, $details, $reindex } = $pricing;
